import { styled } from "@mui/material";
import { MainContainerDesktopId, MainContainerId } from "./MainContainerId";

export const onRtl = (style) => ({
  [`#${MainContainerDesktopId}[dir='rtl'] &, #${MainContainerId}[dir='rtl'] &, .rtl-view &`]: {
    ...style,
  },
});

export const marginRightToMarginLeftOnRtl = (numOfPixels: number) => ({
  marginRight: `${numOfPixels}px`,
  marginLeft: "0px",
  ...onRtl({
    marginLeft: `${numOfPixels}px`,
    marginRight: "0px",
  }),
});

export const marginLeftToMarginRightOnRtl = (numOfPixels: number) => ({
  marginLeft: `${numOfPixels}px`,
  marginRight: "0px",
  ...onRtl({
    marginRight: `${numOfPixels}px`,
    marginLeft: "0px",
  }),
});

export const paddingRightToPaddingLeftOnRtl = (numOfPixels: number) => ({
  paddingRight: `${numOfPixels}px`,
  paddingLeft: "0px",
  ...onRtl({
    paddingLeft: `${numOfPixels}px`,
    paddingRight: "0px",
  }),
});

export const paddingLeftToPaddingRightOnRtl = (numOfPixels: number) => ({
  paddingLeft: `${numOfPixels}px`,
  paddingRight: "0px",
  ...onRtl({
    paddingRight: `${numOfPixels}px`,
    paddingLeft: "0px",
  }),
});

export const MultiLanguageIconContainer = styled("div")({
  ...marginRightToMarginLeftOnRtl(10),
});
